export const INVESTOR_CONTACTS_TYPES = {
  UBO: 'UBO',
  DIRECTOR: 'DIRECTOR',
  CIRCULATION_CONTACT: 'CIRCULATION_CONTACT'
};
